<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body wizard-content">
                        <h4 class="card-title">New Contract</h4>
                        <h6 class="card-subtitle"></h6>
                        <form class="tab-wizard vertical wizard-circle m-t-40 wizard clearfix" id="steps-uid-6" role="application">
                            <div class="steps clearfix">
                                <ul role="tablist">
                                    <li :class="{'current': currentstep === step.id, 'done': step.completed === true}" :currentstep="currentstep" :key="step.id" :step="step" aria-disabled="false"
                                        aria-selected="true" role="tab" v-for="step of steps">
                                        <a :href="step.path_name" aria-controls="steps-uid-6-p-0" id="steps-uid-6-t-0">
                                            <span class="step" v-text="step.id +1"></span> {{step.title}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="content position-absolute clearfix" style="min-width: 75%;">
                                <!-- Steps -->
                                <h4 class="m-b-20">{{steps[currentstep].title}}</h4>
                                <hr>
                                <router-view ref="child"></router-view>
                            </div>
                            <div class="actions clearfix">
                                <ul aria-label="Pagination" role="menu">
                                    <li aria-disabled="true" class="disabled">
                                        <button :disabled="firststep" @click="lastStep" class="btn btn-secondary" type="button">
                                            Back
                                        </button>
                                    </li>
                                    <li aria-disabled="false" aria-hidden="false">
                                        <button :disabled="laststep" @click="nextStep" class="btn btn-success" type="button" v-if="!laststep">
                                            Next
                                        </button>
                                    </li>
                                    <li aria-hidden="true" v-if="laststep">
                                        <button @click="submitContract" class="btn btn-success" type="button" v-if="laststep">
                                            <i class="fa fa-save m-r-5"></i> Submit
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Wizard",
    data() {
        return {
            currentstep: 0,
            contract: {
                type: null,
                partner: null,
                member: null,
                expires_at: null,
                provenance: null,
                items: [],
                goodsSerivces: null,
                goodsSevicesProps: [],
                unit: null,
                quantity: null,
                amount: {
                    amount: null,
                    currency_id: null,
                    currency_name: null,
                    currency_symbol: null
                },
                due: {
                    amount: null,
                    currency_id: null,
                    currency_name: null,
                    currency_symbol: null
                },
                paymentTerms: [],
                pricingTerm: {
                    method: null,
                    currency: null,
                    rate: null,
                    future_exchange: null,
                    future_contract: null,
                    index_exchange: null,
                    index_name: null
                },
                attachments: []
            },
            steps: [
                {
                    id: 0,
                    title: "Contract Property",
                    icon_class: "fas fa-box-open",
                    path_name: "step1",
                    completed: false,
                },
                {
                    id: 1,
                    title: "Goods/Services",
                    icon_class: "fas fa-box-open",
                    path_name: "step2",
                    completed: false
                },
                // {
                //     id: 2,
                //     title: "Pricing Terms",
                //     icon_class: "fas fa-dollar-sign",
                //     path_name: "step3",
                //     completed: false
                // },
                {
                    id: 2,
                    title: "Payment Terms",
                    icon_class: "fas fa-money-bill-alt",
                    path_name: "step4",
                    completed: false
                },
                {
                    id: 3,
                    title: "Attachment",
                    icon_class: "fas fa-paperclip",
                    path_name: "step5"
                },
                {
                    id: 4,
                    title: "Summary",
                    icon_class: "fas fa-edit",
                    path_name: "summary"
                }
            ]
        }
    },
    computed: {
        ...mapGetters(["currentUser", "currentOrg"]),
        active() {
            return this.step.id === this.currentstep;
        },
        firststep() {
            return this.currentstep === 0;
        },
        laststep() {
            return this.currentstep === this.steps.length - 1;
        }
    },
    beforeMount() {
        if(this.currentstep === 0) {
            this.$router.push(this.steps[0].path_name);
        }
    },
    methods: {
        async nextStep() {
            console.log(this.currentstep);
            if(this.currentstep === 2) {
                if(this.contract.type === 'PURCHASE') {
                    this.steps[this.currentstep].completed = true;
                    this.currentstep                       = this.currentstep + 1;
                    this.$router.push(this.steps[this.currentstep].path_name);
                    return;
                }
                if(this.contract.paymentTerms.length > 0 && Number(this.contract.due.amount) === 0) {
                    this.steps[this.currentstep].completed = true;
                    this.currentstep                       = this.currentstep + 1;
                    this.$router.push(this.steps[this.currentstep].path_name);
                } else {
                    this.$toastr('error', 'You have due amount', 'Failed');
                }
            } else if(this.currentstep === 3) {
                this.steps[this.currentstep].completed = true;
                this.currentstep                       = this.currentstep + 1;
                this.$router.push(this.steps[this.currentstep].path_name);
            } else if(this.currentstep === 4) {
                this.steps[this.currentstep].completed = true;
                this.currentstep                       = this.currentstep + 1;
                this.$router.push(this.steps[this.currentstep].path_name);
            } else {
                let valid = await this.$refs.child.validate();
                if(valid) {
                    this.steps[this.currentstep].completed = true;
                    this.currentstep                       = this.currentstep + 1;
                    this.$router.push(this.steps[this.currentstep].path_name);
                }
            }
        },
        lastStep() {
            this.steps[this.currentstep].completed = false;
            this.currentstep                       = this.currentstep - 1;
            this.$router.push(this.steps[this.currentstep].path_name);
        },
        async submitContract() {
            try {
                $(".preloader").fadeIn();
                await this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/contracts`, this.contract);
                $(".preloader").fadeOut();
                this.$toastr('success', 'Contract added successfully', 'Contract Added');
                await this.$router.push({name: 'marketplace-contracts'})
            } catch(e) {
                $(".preloader").fadeOut();
                console.log(e);
            }
        }
    }
}
</script>

<style scoped>

</style>
